import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const BusySlice = createSlice({
  name: 'busy',
  initialState,
  reducers: {
    setBusy(): true {
      return true;
    },
    resetBusy(): false {
      return false;
    },
  },
});

// biome-ignore lint/nursery/useExplicitType: Redux Toolkit action creators are inferred
export const { setBusy, resetBusy } = BusySlice.actions;

export default BusySlice.reducer;
